import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    title: {
      margin: "32px 0",
    },
    sideMenuContainer: {
      display: "flex",
      flexDirection: "row-reverse",
      gap: "16px",
      background: "transparent",
      [theme.breakpoints.down("960")]: {
        flexDirection: "column-reverse",
        gap: "0px",
      },
    },
    filterWrapper: {
      display: "flex",
      flexDirection: "column",
    },
    filtersButtons: {
      alignSelf: "flex-end",
    },
    filtersContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      width: "100%",
      flex: 2,
      maxWidth: "1000px",
      minWidth: "1000px",
      marginTop: "16px",
      "& .input-wrapper": {
        maxWidth: "291px",
      },
      [theme.breakpoints.down("1500")]: {
        minWidth: "initial",
      },
      [theme.breakpoints.down("1345")]: {
        "& .input-wrapper": {
          maxWidth: "190px",
        },
      },
      [theme.breakpoints.down("780")]: {
        "& .input-wrapper": {
          maxWidth: "190px",
        },
      },
      [theme.breakpoints.down("420")]: {
        "& .input-wrapper": {
          maxWidth: "165px",
        },
      },
    },
    inputwrapper: {
      width: "100% !important",
      maxWidth: "392px",
    },
    autoCompleteInput: {
      minWidth: "190px",
      [theme.breakpoints.down("420")]: {
        maxWidth: "165px",
        width: "100% !important",
        minWidth: "initial",
      },
    },
    autoCompleteMedia: {
      minWidth: "291px",
      [theme.breakpoints.down("1345")]: {
        width: "100%",
        minWidth: "initial",
        maxWidth: "190px",
      },
      [theme.breakpoints.down("420")]: {
        maxWidth: "165px",
        width: "100% !important",
        minWidth: "initial",
      },
    },
    searchInput: {
      maxWidth: "291px",
      width: "100% !important",
    },
    searchInputContainer: {
      display: "flex",
      gap: "12px",
    },
    dateFilter: {
      width: "165px",
      marginLeft: "auto",
      padding: "10px 16px",
      fontSize: "16px",
      fontWeight: 600,
      background: theme.palette.background.paper,
      borderRadius: "8px",
      border: `1px solid ${theme.palette.foreground.senary}`,
      alignSelf: "flex-start",
      textAlign: "center",
      [theme.breakpoints.down("780")]: {
        marginLeft: "0",
      },
    },
    dateFilterContainer: {
      display: "flex",
      alignSelf: "flex-start",
      width: "100%",
      marginTop: "16px",
      gap: "12px",
      flex: 1,
      [theme.breakpoints.down("780")]: {
        "& > *": {
          width: "190px",
        },
      },
      [theme.breakpoints.down("420")]: {
        "& > *": {
          width: "165px",
        },
      },
    },
    filterSection: {
      display: "flex",
      [theme.breakpoints.down("780")]: {
        flexDirection: "column",
        maxWidth: "500px",
        width: "100%",
      },
    },
    noDataWrapper: {
      maxWidth: "480px",
      width: "100%",
    },
  };
});
